module.exports = __webpack_public_path__ + "img/image.008803b5.png";